import React, { createContext, useState } from "react";

// Context 생성
export const LoadingContext = createContext();

// Provider 컴포넌트 생성
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
    
  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};